import { createReducer, createActions } from "reduxsauce";
import update from "immutability-helper";

export interface CalendarViewState {
  data: Record<string, any> | null;
  loading: boolean;
  error: string | null;
}

export interface CalendarViewRequestAction {
  query?: Record<string, any>;
  onSuccess?: Function;
}

interface SuccessAction {
  data: Record<string, any>;
}

interface FailureAction {
  error: string;
}

const { Types, Creators } = createActions(
  {
    request: ["query", "onSuccess"],
    success: ["data"],
    failure: ["error"],
    reset: [],
  },
  { prefix: "CALENDAR_VIEW_" }
);

const INITIAL_STATE: CalendarViewState = {
  data: null,
  loading: false,
  error: null,
};

const request = (state: CalendarViewState, action: CalendarViewRequestAction) =>
  update(state, {
    loading: { $set: true },
    error: { $set: null },
  });

const success = (state: CalendarViewState, action: SuccessAction) =>
  update(state, {
    data: { $set: action.data },
    loading: { $set: false },
  });

const failure = (state: CalendarViewState, action: FailureAction) =>
  update(state, {
    loading: { $set: false },
    error: { $set: action.error },
  });

const reset = () => INITIAL_STATE;

/* Reducers to types */
export const calendarView = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.RESET]: reset,
});

export const CalendarViewTypes = Types;
export const CalendarViewActions = Creators;
